import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  WIZARD_STATUS_NOT_STARTED,
  WIZARD_STATUS_COMPLETE,
} from 'platform/site-wide/wizard';

import useSubtaskStatusMarker, {
  setSubtaskStatus,
} from '../useSubtaskStatusMarker';
import { usePathHistory } from '../utils/tracking/PathHistoryContext';
import pageNames from './pageNames';
import SubTaskContainerHeader from '../SubTaskContainerHeader';
import { INTRODUCTION_PAGE } from '../../constants';
import {
  trackSubtaskStepView,
  trackOptOut,
  trackSubtaskViewedWithInProgressForm,
} from '../../utils/tracking/features/subtaskTracking';

const inProgressLinkText =
  'If you have a claim in progress, continue to your application';

/**
 * Sub-task landing page
 * @returns {JSX}
 */
const LandingPage = () => {
  const { addStep, getHistory } = usePathHistory();
  const savedForms = useSelector(
    state => state?.user?.profile?.savedForms || [],
  );

  useSubtaskStatusMarker(WIZARD_STATUS_NOT_STARTED);

  // ──────────────────────────────────────────────
  // STEP VIEW TRACKING
  // ──────────────────────────────────────────────
  useEffect(() => {
    trackSubtaskStepView({
      stepName: pageNames.landing,
      pathHistoryContext: { addStep, getHistory },
    });
    trackSubtaskViewedWithInProgressForm({ savedForms });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id={pageNames.landing}>
      <SubTaskContainerHeader title="Tell us about your claim" />
      <p className="vads-u-margin-top--0">
        We’ll ask you a couple of questions to make sure we direct you to the
        right form.
      </p>
      <p>
        If you already have a claim in progress, you can go straight to the
        application without answering these questions.
      </p>
      <va-link
        href={INTRODUCTION_PAGE}
        text={inProgressLinkText}
        onClick={() => {
          setSubtaskStatus(WIZARD_STATUS_COMPLETE);
          trackOptOut({
            pathHistoryData: getHistory(),
          });
        }}
      />
    </div>
  );
};

export default {
  name: pageNames.landing,
  component: LandingPage,
  back: null,
  next: pageNames.start,
};
